<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div class="bg-cover" :style="'background-image: url(' + $asset('/hkcm/images/auth.png', 'public') + ')'">
            <div class="min-h-screen container mx-auto flex items-center justify-center">
                <div class="bg-white lg:w-1/2 rounded-md my-12">
                    <div
                        class="bg-white text-blue-dark mx-auto w-full transition-all ease-in-out duration-300 rounded-md p-4 lg:p-16 flex flex-col justify-center items-center lg:w-3/4"
                    >
                        <div class="text-center mb-8">
                            <h3>{{ $t('Link expired') }}</h3>

                            <p class="mt-4">
                                {{ $t('Please click on the link to complete the registration.') }}
                            </p>
                        </div>
                        <EmailVerificationNotice />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {};
</script>
